export const SETAScorecards = 'SETAScorecards/';
export const SETAScorecardLicenses = SETAScorecards + 'Licenses';
export const SETAScorecardOrganisationDetails = SETAScorecards + 'OrganisationDetails';
export const SICCodes = 'SICCodes/';
export const RegistrationHasScorecards = SETAScorecards + 'RegistrationHasScorecards';
